import api from '../utils/api';

export default {
    namespaced: true,
    state: {
        providers: [],
    },
    getters: {
        limitedProviderList(s, count) {
            return s.providers.slice(0, (s.providers.length >= count) ? count : s.providers.length);
        },
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST(s, data) {
            s.providers = data;
        },
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL(context) {
            return api
                .get('/datastoreProviders')
                .then(response => context.commit('LIST', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/datastoreProviders.js